import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { faqappend, getlogid } from '@/redux/faq/action';
import { MyThunkResult } from '@/typings/reducer';
import { IM_FAQ_HOT_LABEL, IM_MESSAGE } from '@/typings/global';
import { outline } from '@/helpers/online';
import { faqChoice } from '@/helpers/faq';

function index(): JSX.Element {
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { hot_label } = useSelector(
        ({ FaqReducer }) => ({
            hot_label: FaqReducer.hot_label
        }),
        shallowEqual
    );
    const _handleClick = async (item: IM_FAQ_HOT_LABEL) => {
        if (outline(1)) return;
        const { faq_list, label } = item;
        await dispatch(faqappend({ message: label, type: 'out' }));
        const { log_id } = await dispatch(
            getlogid({ input: item.label, faq_ids: item.faq_ids.toString() })
        );
        const msg = await faqChoice({ ...item, log_id }, faq_list, 'hot_label');
        await dispatch(faqappend(msg as IM_MESSAGE));
    };
    return (
        !_.isEmpty(hot_label) && (
            <ul className="im-hotlabel-container">
                {hot_label.map((item, ind) => (
                    <li key={`hot-label${ind + 1}`} onClick={() => _handleClick(item)}>
                        {item.label}
                    </li>
                ))}
            </ul>
        )
    );
}

export default index;
